import * as MiseAuth from "mise-react-redux-auth0-2";
import Auth0 from "../auth/Auth";

const { getAuthActions } = MiseAuth;

const actions = getAuthActions(Auth0);

export default actions;
